import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import Cookies from "js-cookie";

/* eslint-disable */
export default {
  namespaced: true,
  state: {
    appName: Cookies.get("appName"),
    appEditeur: Cookies.get("appEditeur"),
    appVersion: Cookies.get("appVersion"),
    appTimeZone: Cookies.get("appTimeZone"),
    appDateFormat: Cookies.get("appDateFormat"),
    appHeureFormat: Cookies.get("appHeureFormat"),
    appDevise: Cookies.get("appDevise"),
    tva: Cookies.get("tva"),
    isLoad: Cookies.get("isLoad") ? Cookies.get("isLoad") : false,
    locale: Cookies.get("locale") ? Cookies.get("locale") : 'fr',
    /***LOADER**/
    isLoading: false,
    fullPage: false,
    canCancel: false
  },
  actions,
  getters,
  mutations
};
